import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { extractSelectedTicketIdFromState } from '../../../extractFromState';
import { Timer, LoadingBar, ChatTabBarBackground, ChatTabBar, ChatTabLabel } from './ExpiryTimer.styles';
import { calcExpiryTime } from 'util/timerUtil';
import { ONE_MINUTE, ONE_SECOND } from './constants';

const ExpiryTimer = ({
  loadingBar,
  chatTab,
  conversationUpdatedAt,
  ticketId,
  selectedTicketId,
  lastMessageSource,
  ticketExpiresIn,
}) => {
  const [chatExpiresIn, setChatExpiresIn] = useState(null);

  useEffect(() => {
    const remainingTime = calcExpiryTime(conversationUpdatedAt, ticketExpiresIn);
    setChatExpiresIn(remainingTime);

    const interval = setInterval(() => {
      setChatExpiresIn((_chatExpiresIn) => _chatExpiresIn - ONE_SECOND);
    }, ONE_SECOND);

    // cleanup on unmount
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [conversationUpdatedAt, lastMessageSource]);

  const calcTextTimer = (milliseconds) => {
    const minutes = Math.floor(milliseconds / ONE_MINUTE);
    const seconds = ((milliseconds % ONE_MINUTE) / ONE_SECOND).toFixed(0);

    return milliseconds && `${minutes < 10 ? `0${minutes}` : minutes} : ${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const calcLoadingBarPercent = (currTimer) => ((ticketExpiresIn - currTimer) * 100) / ticketExpiresIn - 100;

  if (chatExpiresIn > 1) {
    if (loadingBar) {
      if (chatTab) {
        const seconds = Math.floor(chatExpiresIn / 1000);
        const label = seconds > 60 ? `${Math.floor(seconds / 60)} mins` : `${seconds} sec`;

        return (
          <>
            <ChatTabBarBackground isSelectedTicket={selectedTicketId === ticketId}>
              <ChatTabBar
                percent={calcLoadingBarPercent(chatExpiresIn)}
                isSelectedTicket={selectedTicketId === ticketId}
              />
            </ChatTabBarBackground>
            <ChatTabLabel>{label}</ChatTabLabel>
          </>
        );
      }

      return (
        <LoadingBar isSelectedTicket={selectedTicketId === ticketId} percent={calcLoadingBarPercent(chatExpiresIn)} />
      );
    }

    return <Timer>{`Expires in: ${calcTextTimer(chatExpiresIn)}`}</Timer>;
  }

  return null;
};

const mapStateToProps = (state) => ({
  selectedTicketId: extractSelectedTicketIdFromState(state),
});

export default connect(mapStateToProps)(ExpiryTimer);
